import axios from './index';

export const getDashboardRequest = () => axios.get(`/v1/admins/get/admin/dashboard`);
